export default "__VITE_ASSET__DahDL7AN__"